import React, { Component } from 'react';

const Container = ({children}) => (
    <div className="Container">
        {children}
    </div>
)

export default Container;


// WEBPACK FOOTER //
// ./containers/Container.js